// features/user/userSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchUserDetails } from "./userThunks";

const userSlice = createSlice({
  name: "user",
  initialState: {
    details: [],
    loading: false,
    searchGroup : "",
    error: null,
  },
  reducers: {
     setSearchGroup: (state, action) => {
      state.searchGroup = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { 
 setSearchGroup
} = userSlice.actions;
export default userSlice.reducer;
